export const CARTE_UPDATE_RESET = "CARTE_UPDATE_RESET";
export const CARTE_UPDATE_SET_UPDATED = "CARTE_UPDATE_SET_UPDATED";
export const CARTE_UPDATE_SET_ERROR = "CARTE_UPDATE_SET_ERROR";
export const CARTE_UPDATE_TOGGLE_LOADING = "CARTE_UPDATE_TOGGLE_LOADING";
